import Vue from 'vue'
import VueRouter from 'vue-router'
import { getButtonPermiss } from "@/utils/request";
import store from "@/store";

import login from '../views/login'
import layout from '../views/index'
import Home from '../views/home'
import HotelManage from '../views/hotelManage/index';
import RoomConditionList from '../views/hotelManage/roomConditionList/index';
import RoomDynamics from '../views/hotelManage/roomDynamics/index'; 
import PreOrderList from '../views/hotelManage/preOrderList/index'; 
import AduitHotelList from '../views/hotelManage/aduitHotelList/index';  
import MenuManage from "../views/sysSetting/menuManage/index";
import RoleManage from "../views/sysSetting/roleManage/index";
import DictManage from "../views/sysSetting/dictManage/index";
import WxManage from "../views/sysSetting/wxManage/index";
import WxAccountManage from "../views/sysSetting/wxAccountManage/index";
import WxMerchant from "../views/sysSetting/wxMerchant/index";
import UserManage from "../views/userManage/index";
import LogManage from "../views/sysSetting/logManage/index";
import UserInfo from "../views/userInfo/index";
import WithdrawalManage from "../views/financeManage/withdrawalManage/index";
import StatementRecord from "../views/financeManage/statementRecord/index";
import EnterpriseCredit from "../views/enterpriseMKanage/enterpriseCredit/index";
import EnterpriseRecord from "../views/enterpriseMKanage/enterpriseRecord/index";
import PromotionRecord from '@/views/hotelManage/promotionRecord/index'
import WxTemplate from '@/views/sysSetting/wxTemplate/index'

Vue.use(VueRouter)

const routes = [
    {
        path: '/',
        redirect: '/login'
    },
    {
        path: '/login',
        component: login
    },
    {
        name: 'index',
        path: '/index',
        component: layout,
        children: [
            {
                path: '',
                name: ' ',
                component: Home
            },
            {
                path: 'userInfo',
                name: 'userInfo',
                component: UserInfo
            },
            {
                path: 'retailList',
                name: 'retailList',
                component: () => import('@/views/retailManage/index')
            },
            {
                path: 'hotel',
                name: 'hotel',
                component: HotelManage
            },
            {
                path: 'roomConditionList',
                name: 'roomConditionList',
                component: RoomConditionList
            },
            {
                path: 'roomDynamics',
                name: 'roomDynamics',
                component: RoomDynamics
            },
            {
                path: 'preOrderList',
                name: 'preOrderList',
                component: PreOrderList
            },
            {
                path: 'refundOrderList',
                name: 'refundOrderList',
                component: () => import('@/views/hotelManage/refundOrderList/index')
            },
            {
                path: 'promotionRecord',
                name: 'promotionRecord',
                component: PromotionRecord
            },
            {
                path: 'aduitHotelList',
                name: 'aduitHotelList',
                component: AduitHotelList
            },
            {
                path: 'statementRecord',
                name: 'statementRecord',
                component: StatementRecord
            },
            {
                path: 'withdrawalManage',
                name: 'withdrawalManage',
                component: WithdrawalManage
            },
            {
                path: 'enterpriseRecord',
                name: 'enterpriseRecord',
                component: EnterpriseRecord
            },
            {
                path: 'enterpriseCredit',
                name: 'enterpriseCredit',
                component: EnterpriseCredit
            },
            {

                path: 'menuManage',
                name: 'menuManage',
                component: MenuManage
            },
            {

                path: 'roleManage',
                name: 'roleManage',
                component: RoleManage
            },
            {

                path: 'dictManage',
                name: 'dictManage',
                component: DictManage
            },
            {
                path: 'wxManage',
                name: 'wxManage',
                component: WxManage

            },

            {
                path: 'wxAccountManage',
                name: 'wxAccountManage',
                component: WxAccountManage
            },

            {
                path: 'wxMerchant',
                name: 'wxMerchant',
                component: WxMerchant
            },
            {
                path: 'wxTemplate',
                name: 'wxTemplate',
                component: WxTemplate
            },
            
            {
                path: 'userManage',
                name: 'userManage',
                component: UserManage
            },
            {
                path: 'logManage',
                name: 'logManage',
                component: LogManage
            },
        ]
    }
]

const router = new VueRouter({
    routes
})

//路由前置守卫
router.beforeEach((to, from, next) => {
    if (store.state.buttonList.length) {
        // console.log(getButtonPermiss(store.state.buttonList || [], to.name),"按钮权限")
        store.commit("SET_PAGE_PERMISSION", getButtonPermiss(store.state.buttonList || [], to.name))
    }
    next();
    if (to.path === '/login') {
        next();
    } else {
        let Token = localStorage.getItem('Token')
        if (Token === null || Token === '') {
            next('/login')
            console.log('没有token，跳转到登录页面');
        } else {
            // console.log('路由守卫触发');
            next();
        }
    }



    // document.getElementById("app").style.display="none";
    // if (to.path === '/login'||to.path === '/newPswForget'||to.path === '/emailVerify') {
    //     next();
    // } else {
    //     let Token = localStorage.getItem('Token');
    //     if (Token === null || Token === '') {
    //         next('/login');
    //         console.log('没有token')
    //     } else {
    //         next();
    //     }
    // }


});

export default router
